import React from 'react';
import { COLORS } from '../QuestionChartConfig';

const PreferenceOrderLegend = ({ question }) => {
  const results = question.results || [];
  const sortedResults = [...results].sort((a, b) => Number(b.value) - Number(a.value));

  let currentRank = 1;
  const rankedResults = sortedResults.map((item, idx) => {
    if (idx > 0 && Number(item.value) < Number(sortedResults[idx - 1].value)) {
      currentRank += 1;
    }
    return {
      ...item,
      rank: currentRank
    };
  });

  return (
    <div className="survey-result-details-list">
      {rankedResults.map(item => {
        const originalIdx = results.findIndex(r => r.name === item.name);
        const itemColor = originalIdx !== -1 ? COLORS[originalIdx % COLORS.length] : '#ccc';

        return (
          <div key={item.id || item.name} className="details-list-row">
            <div className="details-list-left">
              <span className="survey-result-color-dot" style={{ backgroundColor: itemColor }} />
              <span className="details-list-name">{item.name}</span>
            </div>
            <div className="details-list-right">
              <div className="details-list-pct" style={{ fontWeight: 'bold' }}>
                {item.rank}°
              </div>
              <div className="details-list-count">
                {item.value} {item.value === 1 ? 'pt' : 'pts'}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PreferenceOrderLegend;
